import React, { useState, useEffect, forwardRef } from "react";
import { Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

const PaymentSummary = ({
  paymentItems,
  setNoUnmatched,
  checked1,
  checked2,
  checked3,
  checked4,
}) => {
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  //set rows data
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows([]);
    if (paymentItems.length > 0) {
      var total_unmatched = 0;
      var total_gross = 0;
      var total_paypal_express = 0;
      var total_paypal_billing = 0;
      var total_visa = 0;
      var total_master = 0;
      var counts = 0;
      var date_array = [];

      let selectedPaymentType = [];
      if (checked1) {
        selectedPaymentType.push("PAYPAL_EXPRESS");
      }
      if (checked2) {
        selectedPaymentType.push("PAYPAL_BILLING_AGREEMENT");
      }
      if (checked3) {
        selectedPaymentType.push("VISA");
      }
      if (checked4) {
        selectedPaymentType.push("MASTER");
      }

      for (let x in paymentItems) {
        let each = paymentItems[x];
        if (selectedPaymentType.includes(each.payment_type)) {
          date_array.push(each.create_time);

          if (each.shopify === "Unmatched") {
            total_unmatched += 1;
          }
          if (each.payment_type === "PAYPAL_BILLING_AGREEMENT") {
            total_paypal_billing += 1;
          }
          if (each.payment_type === "PAYPAL_EXPRESS") {
            total_paypal_express += 1;
          } else if (each.payment_type === "VISA") {
            total_visa += 1;
          } else if (each.payment_type === "MASTER") {
            total_master += 1;
          }
          total_gross += parseFloat(each.gross);
          counts += 1;
        }
      }
      // setNoUnmatched to disabled Unmatched checkbox when no data is unmatched
      if (total_unmatched === 0) {
        setNoUnmatched(true);
      } else {
        setNoUnmatched(false);
      }

      // Get latest and oldest date in paymentItems
      let date_range = "";
      if (date_array.length > 0) {
        var latest = date_array[0].split(",");
        var latest_GMT = new Date(date_array[0]);
        var oldest = date_array[0].split(",");
        var oldest_GMT = new Date(date_array[0]);
        for (let x in date_array) {
          if (new Date(date_array[x]) > latest_GMT) {
            latest = date_array[x].split(",");
            latest_GMT = new Date(date_array[x]);
          }
          if (new Date(date_array[x]) < oldest_GMT) {
            oldest = date_array[x].split(",");
            oldest_GMT = new Date(date_array[x]);
          }
        }
        date_range = oldest[0] + " - " + latest[0];
      }

      setRows((rows) => [
        ...rows,
        {
          date_range: date_range,
          total_gross: total_gross.toFixed(2) + " USD",
          total_paypal_express: total_paypal_express,
          total_paypal_billing: total_paypal_billing,
          total_visa: total_visa,
          total_master: total_master,
          total_unmatched: total_unmatched,
          transcation_counts: counts,
        },
      ]);
    }
    //eslint-disable-next-line
  }, [paymentItems, checked1, checked2, checked3, checked4]);

  const rowEvents = (event, disputeID) => {};
  const column = [
    {
      field: "date_range",
      title: "Date Range",
      cellStyle: {
        width: 200,
        minWidth: 200,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "total_gross",
      title: "Total Gross",
      cellStyle: {
        width: 150,
        minWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "total_paypal_express",
      title: "Total Paypal Express",
      cellStyle: {
        width: 150,
        maxWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "total_paypal_billing",
      title: "Total Paypal Billing Agreement",
      cellStyle: {
        width: 150,
        maxWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "total_visa",
      title: "Total Visa",
      cellStyle: {
        width: 150,
        maxWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "total_master",
      title: "Total Master",
      cellStyle: {
        width: 150,
        maxWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "total_unmatched",
      title: "Total Unmatched",
      cellStyle: {
        width: 150,
        maxWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
    {
      field: "transcation_counts",
      title: "Total Records",
      cellStyle: {
        width: 150,
        maxWidth: 150,
        fontSize: 13,
        textAlign: "center",
      },
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MaterialTable
          columns={column}
          data={rows}
          icons={tableIcons}
          onRowClick={(event, rowData) => rowEvents(event, rowData.dispute_id)}
          options={{
            search: false,
            rowStyle: {
              height: 25,
            },
            paging: false,
            showTitle: false,
            toolbar: false,
            sorting: false,
            draggable: false,
            headerStyle: {
              fontWeight: "bold",
              fontSize: 13,
              textAlign: "center",
              zIndex: 0,
            },
          }}
        />{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default PaymentSummary;
